/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_D2dInputs */

const en_mk_sol_agensi_d2d = /** @type {(inputs: Mk_Sol_Agensi_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The issue is assigned to the Marketing agent. It reads that client’s brand rules from Company memory and posts a draft as a comment.`)
};

const id_mk_sol_agensi_d2d = /** @type {(inputs: Mk_Sol_Agensi_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue di-assign ke agen Marketing. Ia membaca aturan brand klien itu dari Memori perusahaan, lalu menaruh draf sebagai komentar.`)
};

/**
* | output |
* | --- |
* | "The issue is assigned to the Marketing agent. It reads that client’s brand rules from Company memory and posts a draft as a comment." |
*
* @param {Mk_Sol_Agensi_D2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_d2d = /** @type {((inputs?: Mk_Sol_Agensi_D2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_D2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_d2d(inputs)
	return en_mk_sol_agensi_d2d(inputs)
});